const invoice = {
    state: () => ({
        items : [],
        selectedPaymentMethods : [],
        paymentMethods: [],
        transaction : {},
        invoice : {},
        currentSettings : {},
        currencies: [],
        itemCredits: [],
    }),

    mutations: {
        setItemCredits (state, itemCredits) {
            state.itemCredits = itemCredits;
        },

        setTransaction (state, transaction) {
            state.transaction = transaction;
        },

        setItems (state, items) {
            state.items = items;
        },

        setSelectedPaymentMethods (state, paymentMethods) {
            state.selectedPaymentMethods = paymentMethods
        },

        setInvoice (state, invoice) {
            state.invoice = invoice;
        },

        setInvoicePaidAt (state, value) {
            state.invoice.paid_at = value;
        },

        setCurrentSettings (state, currentSettings) {
            state.currentSettings = currentSettings;
        },

        setPaymentMethods (state, paymentMethods) {
            state.paymentMethods = paymentMethods;
        },

        setCurrencies (state, currencies) {
            state.currencies = currencies;
        },

        addExtraItem (state, extraItem) {
            state.items.push(extraItem);
        },

        addPaymentMethod (state, payload) {
            state.transaction.total_balance_due  = parseFloat(state.transaction.total_balance_due).toFixed(payload.decimalPlaces);
            // state.transaction.total_balance_due += paymentMethod.charge_amount;
            state.transaction.total_balance_due -= payload.paymentMethod.payment_amount;

            state.selectedPaymentMethods.push(payload.paymentMethod);
        }
    },

    getters: {
        getTransaction (state) {
            return state.transaction;
        },

        getInvoice (state) {
            return state.invoice;
        },

        getSelectedPaymentMethods (state) {
            return state.paymentMethods;
        },

        getItems (state) {
            return state.items;
        },

        getCurrentSettings (state) {
            return state.currentSettings;
        },

        getPaymentMethods (state) {
            return state.paymentMethods;
        },

        getCurrencies (state) {
            return state.currencies;
        },

        getItemCredits (state) {
            return state.itemCredits;
        }
    }
}

export default invoice;
